<template>
  <div>
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('labelSearch')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="data"
        item-key="name"
        class="elevation-1 mb-3 historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :single-select="false"
        :show-select="result == 2"
        :items-per-page="result == 2 ? -1 : 10"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
        </template>
        <template v-slot:item.name_user="{ item }">
          <p class="mb-0 caption">{{ `Ap .: ${item.punter}` }}</p>
          <a
            @click="
              $profile.showProfileDrawer(
                item.id_agent,
                'regionalManager/agents/getAgent'
              )
            "
          >
            <v-icon color="blue" x-small>mdi-account</v-icon>
            <p class="caption">{{ `Ag .: ${item.name_user}` }}</p>
          </a>
        </template>

        <template v-slot:item.date="{ item }">
          {{ item.date }}
        </template>

        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div class="py-2">
              <div
                v-for="(event, index) in item.events"
                :key="index"
                class="caption"
              >
                {{ event.description }} (
                {{ $infoTable.markets(event.id_market).name_market || "" }} -
                {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }} -
                {{ event.factor_event }}) &nbsp;
                <span
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></span>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="primary"
                  v-if="event.live_event == '1'"
                >
                  ao vivo
                </v-chip>
              </div>
            </div>
          </template>
          <template v-else>
            {{ item.qtd_events }}
          </template>
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>

        <template v-slot:item.paid="{ item }">
          <v-icon
            class="white--text"
            :color="item.paid == '0' ? 'orange' : ' green darken-3'"
            >{{ item.paid | formatPaid }}</v-icon
          >
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn
              small
              :title="$t('view')"
              @click="$bet.showBetDialog(item.id, item.printed)"
            >
              <v-icon size="24">mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>

    <!-- Resume Perído -->
    <div class="mt-4" v-if="resume.prizeTotal && resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">
              {{ $t("periodSummary") }}
              <div class="caption">{{ $store.state.rangeUI }}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("valueLabel") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("paidPrizes") }}</td>
                    <td class="text-right red--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("possiblePrizes") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("totalPrizes") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "local-manager-bet-historic",

  data: () => ({
    data: [],
    search: "",
    selected: [],
    tabCancel: false,

    // Resume
    resume: {},
  }),
  mounted() {},
  computed: {
    // ====================================================
    // Retrieve Filters
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    status() {
      return this.$store.state.filters.selectStatusBet.status;
    },
    result() {
      return this.$store.state.filters.selectResultBet.result;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      var items = [
        // ocultos para tratamentos (nao altere)
        { text: "Evento Editado", value: "events_edited", align: " d-none" },
        { text: "Valor_some", value: "amount", align: " d-none" },
        { text: "", value: "punter", align: " d-none" },
        // { text: "Pagar", value: "select", sortable: false, align: " d-none" },
        { text: this.$t("idLabel"), value: "id" },
        { text: this.$t("infosLabel"), value: "name_user" },
        { text: this.$t("eventsLabel"), value: "events", width: 400 },
        { text: this.$t("dateLabel"), value: "date" },
        { text: this.$t("valueLabel"), value: "amount" },
        { text: this.$t("returnLabel"), value: "prize" },
        { text: this.$t("resultLabel"), value: "result_bet" },
        { text: this.$t("paidLabel"), value: "paid" },
        { text: this.$t("actionsLabel"), value: "action" },
      ];

      // Insere o Qtd Events em uma coluna especifica apenas para desktop
      if (this.$vuetify.breakpoint.smAndUp) {
        items.splice(5, 0, {
          text: "Qtd.",
          value: "qtd_events",
        });
      }

      return items;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
      this.data = [];
    },

    async requestApi() {
      this.resetPage();
      const body = {
        ...this.rangeDate,
        id_local: this.id_local || "",
        id_agente: this.id_agent || "",
        status: this.status,
        resultado: this.result,
        tipo: this.eventNumber,
      };
      const request = await this.$request.post(
        "/regionalManager/bets/list",
        body
      );
      this.rowsPerPageItems = request.length;
      this.data = request.length == 0 ? [] : request.dados.apostas;
      for (const item of this.data) {
        let qtd_events = this.qtdEvents(item.events.length);
        item.date = new Date(item.date.replace(" ", "T")).toLocaleString();
        this.$set(item, "name", item.id);
        let events = "";
        for (const e of item.events) {
          events += `${e.description} ${qtd_events}
          ${new Date(item.date).toLocaleString()}
          ${this.$infoTable.markets(e.id_market).name_market}
          ${this.$infoTable.outcomes(e.id_outcome).name_outcome}
          ${this.$infoTable.results(item.result_bet)}
          ${this.$infoTable.paid(item.paid)}`;
        }
        this.$set(
          item,
          "size",
          item.events.length >= 4 ? 4 : item.events.length
        );
        this.$set(item, "select", false);
        this.$set(item, "conference", this.$infoTable.results(item.result_bet));
        this.$set(item, "events_edited", events);
        this.$set(item, "qtd_events", qtd_events);
      }
      // Build Resume and add value to reducer
      this.resume = this.$resume.resumeBet(this.data);
    },
    qtdEvents(val) {
      const text = {
        1: `1 (${this.$t("simple")})`,
        2: `2 (${this.$t("duo")})`,
        3: `3 (${this.$t("triple")})`,
      };
      return text[val] ? text[val] : `${val} ${this.$t("eventsLabel")}`;
    },
  },
  filters: {
    formatPaid(val) {
      const format = val == 1 ? "mdi-check" : "mdi-close";
      return format;
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.historic-bet td.v-data-table__mobile-row:nth-child(2),
.historic-bet td.v-data-table__mobile-row:nth-child(3),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(4) {
  height: 56px !important;
  font-size: 18px;
}
</style>
